export const checkIfAllowedInput = (value) => {
  let test = true;
  if (value.length === 1) test = /^[0-9]$/.test(value);
  if (value.length === 2) test = /^[1-9][0-9]$/.test(value) || /^[0-9],$/.test(value);
  if (value.length > 2) test = /^[0-9,]*$/.test(value);
  const match = value.match(/,([\s\S]*)$/);
  if (match && match[1].length > 2) test = false;
  return test;
};
